const rightPanelKey = 'RIGHT_PANELS_STATE_';

function UserPreferencesService(LocalStorageService) {
    this.local = LocalStorageService;
}

UserPreferencesService.prototype.saveRightPanelState = function (key, rightPanel) {
    this.local.setItem(rightPanelKey + key, rightPanel);
};

UserPreferencesService.prototype.loadRightPanelState = function (shopperId) {
    return this.local.getItem(rightPanelKey + shopperId);
};

module.exports = UserPreferencesService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/user-preferences/user-preferences-service.js
 **/